import { nextTick } from 'vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const generatePDF = async (element, docName) => {
  if (!element) {
    console.error('element not found')
    return
  }

  await nextTick()

  const elementEl = element.$el.cloneNode(true)
  elementEl.style.transform = 'translate(2000px)'
  elementEl.style.position = 'absolute'
  elementEl.style.width = '863px'

  elementEl.querySelectorAll('.expanded-panel').forEach(panel => {
    ;(panel as HTMLElement).style.display = 'block'
  })

  document.body.appendChild(elementEl)

  if (!elementEl || !elementEl.innerHTML) {
    console.error('Вміст документа відсутній')
    return
  }

  try {
    const canvas = await html2canvas(elementEl, {
      useCORS: true,
      scale: 2,
      backgroundColor: '#fff',
      windowWidth: 863,
      windowHeight: elementEl.scrollHeight,
    })

    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = 210 // Ширина сторінки A4 у mm
    const pageHeight = 297 // Висота сторінки A4 у mm
    const margin = 10 // Відступи
    const imgWidth = pageWidth - margin * 2 // Ширина зображення
    const chunkHeight = pageHeight - margin * 2 // Скільки вміщається на 1 сторінку
    const yPosition = margin // Початкова позиція Y

    let position = 0 // Поточна позиція обрізання

    while (position < canvas.height) {
      const chunkCanvas = document.createElement('canvas')
      chunkCanvas.width = canvas.width
      chunkCanvas.height = chunkHeight * (canvas.width / imgWidth) // Масштаб під розмір A4
      const ctx = chunkCanvas.getContext('2d')

      ctx.drawImage(
        canvas,
        0,
        position,
        canvas.width,
        chunkHeight * (canvas.width / imgWidth),
        0,
        0,
        chunkCanvas.width,
        chunkCanvas.height
      )

      const chunkImgData = chunkCanvas.toDataURL('image/png')

      pdf.addImage(chunkImgData, 'PNG', margin, yPosition, imgWidth, 0)

      position += chunkHeight * (canvas.width / imgWidth)

      if (position < canvas.height) {
        pdf.addPage()
      }
    }

    pdf.save(`${docName}.pdf`)
    console.log('pdf success saved')
    document.body.removeChild(elementEl)
  } catch (error) {
    console.error('Помилка при створенні PDF:', error)
  }
}

export { generatePDF }
